import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  DateField as AriaDateField,
  DateFieldProps,
  DateValue,
} from "react-aria-components";

import { sharedStyles } from "../../styles";

export function _DateField<T extends DateValue>(props: DateFieldProps<T>) {
  const className = css(sharedStyles.field);

  return <AriaDateField {...mergeProps(props, { className })} />;
}
